import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Box from "@material-ui/core/Box";

// const iconWidth = 54;
// const drawerWidth = 220;
const iconWidth = 70;
const drawerWidth = 220;
const styles = theme => ({
  defaultRoot: {
    display: 'flex',
    marginTop: '30px',
    marginLeft: iconWidth,
    width: `calc(100%-${iconWidth}px)`,
    backgroundColor: '#f8ffff',
  },
  drawerRoot: {
    display: 'flex',
    marginTop: '30px',
    marginLeft: drawerWidth,
    width: `calc(100%-${drawerWidth}px)`,
    backgroundColor: '#f8ffff',
  },
  drawerRootXs: {
    display: 'flex',
    marginTop: '30px',
    backgroundColor: '#f8ffff',
  },
});

class AutoSizeView extends React.Component {
  
  render() {
    const { classes, openDrawer, component: Component, ...others } = this.props;

    return (
      <div>
        <Component {...others} />
      </div>
    );
  }
}

AutoSizeView.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  openDrawer: state.style.openDrawer,
});

const mapDispatchToProps = {
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(AutoSizeView))
);
